import React, {Component} from 'react';
import Form from 'react-bootstrap/Form';
import FormUA from './UA/PackageFormUA';
import jwtClient from "../JwtClient";
import PackageFormRU from "./RUnew/PackageFormRU";


function CountryRadioButtons(props) {
    let countries = Object.keys(props.countryLms).reverse();
    let label, value, id, defaultChecked;
    return <div>
        <Form.Group>
            {
                countries.map((c, index) => {
                    defaultChecked = c === "UA" || countries.length === 1;
                    if (c === "UA") {
                        label = "UKRAINE";
                        value = "UA";
                        id = "UA";
                    } else {
                        label = "RUSSIA";
                        value = "RU";
                        id = "RU";
                    }
                    return <Form.Check
                        key={index}
                        defaultChecked={defaultChecked}
                        inline
                        type="radio"
                        name="country_code"
                        label={label}
                        value={value}
                        id={id}
                        onClick={props.handleCountryClick}
                    />

                })
            }
        </Form.Group>
    </div>
}


export default class PackageForm extends Component {
    state = {country: '', countryLms: {}};

    render() {
        let form;
        if (this.state.country === 'RU') {
            // form = <FormRU lmsList={this.state.countryLms['RU'] || []}/>;
            const bxb = this.state.countryLms['RU'][0]
            form = <PackageFormRU lmsID={bxb.id} lmsCode={bxb.code} lmsName={bxb.name}/>
        } else {
            form = <FormUA lmsList={this.state.countryLms['UA'] || []}/>;
        }
        return (
            <div>
                <h2 className="mt-3">Add Package</h2>
                <CountryRadioButtons countryLms={this.state.countryLms} handleCountryClick={this.handleCountryClick}/>
                {form}
            </div>
        );
    }

    handleCountryClick = e => {
        this.setState({country: e.target.value})
    };

    // TODO in case of error show error
    componentDidMount() {
        jwtClient.get('/api/v1/last-mile-service/list')
            .then((response) => {
                let country;
                if ('RU' in response.data && !('UA' in response.data)) {
                    country = 'RU';
                } else {
                    country = 'UA';
                }
                this.setState({
                    country: country,
                    countryLms: response.data,
                });
            })
    }
}
